import { render } from "./App.vue?vue&type=template&id=689f0c88"
const script = {}

import "./App.vue?vue&type=style&index=0&id=689f0c88&lang=scss"

import exportComponent from "/Users/jevons/Documents/Vue/activity_drawform/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__